import { Radio as AntRadio } from 'antd'
import type { ComponentProps } from 'react'

type AntRadioProps = ComponentProps<typeof AntRadio>

export interface AppRadioProps extends AntRadioProps {}

export const AppRadio = ({ ...rest }: AppRadioProps) => <AntRadio {...rest} />

export const AppRadioGroup = AntRadio.Group
export const AppRadioButton = AntRadio.Button
